import {
  DialogOffset
} from "./chunk-WOVMNRL4.mjs";
import {
  cn
} from "./chunk-DYSUVPH5.mjs";
import {
  usePreventScroll
} from "./chunk-CFUZ2BU3.mjs";

// src/components/drawer-container/drawer-container.tsx
import { Dialog, DialogPanel, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
var drawContainerClassNames = {
  root: "fixed inset-0 z-20 overflow-y-auto",
  overlay: "fixed inset-0 bg-black/70",
  container: "fixed"
};
var transitionPropsForAnchor = {
  left: {
    enterFrom: "opacity-0 -translate-x-full",
    enterTo: "opacity-100 translate-x-0",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  },
  right: {
    enterFrom: "opacity-0 translate-x-full",
    enterTo: "opacity-100 translate-x-0",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  },
  top: {
    enterFrom: "opacity-0 -translate-y-full",
    enterTo: "opacity-100 translate-y-0",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  },
  bottom: {
    enterFrom: "opacity-0 translate-y-full",
    enterTo: "opacity-100 -translate-y-0",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }
};
var containerClassNamesForAnchor = {
  left: "h-full left-0",
  right: "h-full right-0",
  top: "w-full top-0",
  bottom: "w-full bottom-0"
};
var DrawerContainer = ({
  anchor = "left",
  isBodyLockable = true,
  isOpen,
  onClose,
  className,
  initialFocusRef,
  children
}) => {
  usePreventScroll({
    isDisabled: !isOpen || !isBodyLockable
  });
  return /* @__PURE__ */ React.createElement(Transition, { show: isOpen, as: Fragment }, /* @__PURE__ */ React.createElement(
    Dialog,
    {
      onClose,
      className: cn(drawContainerClassNames.root, className?.root),
      initialFocus: initialFocusRef
    },
    /* @__PURE__ */ React.createElement(DialogOffset, null),
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cn(drawContainerClassNames.overlay, className?.overlay)
      }
    ),
    /* @__PURE__ */ React.createElement(
      Transition.Child,
      {
        as: Fragment,
        enter: "transition ease-out duration-300",
        leave: "transition ease-in duration-300",
        ...transitionPropsForAnchor[anchor]
      },
      /* @__PURE__ */ React.createElement(DialogPanel, null, /* @__PURE__ */ React.createElement(
        "div",
        {
          className: cn(
            drawContainerClassNames.container,
            containerClassNamesForAnchor[anchor],
            className?.container
          )
        },
        children
      ))
    )
  ));
};

export {
  DrawerContainer
};
